import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";
export const COLUNAS_DEFAULT_MODULE_MATERIA_PRIMA = [
  {
    module: 'MATERIA_PRIMA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'unidade.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'categoria.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'quantidade'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_minima'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'usa_grade'
      }
    ]
  },
  {
    module: 'GRADE_MATERIA_PRIMA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'sku'
      },
      {
        active: true,
        removable: true,
        field: 'materia_prima.categoria.descricao'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'quantidade'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_minima'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      }
    ]
  },
  {
    module: 'RSE_MATERIA',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'observacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'AJUSTE_ESTOQUE',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'observacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'TMP_MATERIA',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'observacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'REE_MATERIA',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'data_compra',
        active: true,
        removable: true
      },
      {
        field: 'data_recebimento',
        active: true,
        removable: true
      },
      {
        field: 'fornecedor.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'CATEGORIA_MATERIA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'classificacao'
      }
    ]
  },
  {
    module: 'VARIACAO_MATERIA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  }
] as IColunasSettingsUser[];
